/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line import/no-extraneous-dependencies
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetStoreRecords = (data: any) =>
  useQuery({
    queryKey: [
      "GetStoreRecords",
      data?.pageNumber,
      data?.pageRowCount,
      data?.searchCriteria,
      data?.cashCenterId,
      data?.region,
      data?.operationDate,
    ],
    queryFn: () => client(`daily/operations/rosters`, { data }),
  });

export const useExportRosters = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/rosters/export`, { data }),
  });

export const useEditDailyOperationRosters = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/edit/roster`, {
        data,
        successMessage: "Roster updated successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["EditDailyOperationRoster"] });
    },
  });
};

export const useGetRouteServices = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/route/services`, { data }),
  });

export const useGetDispatchTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (date: string) => {
      return client(`daily/operations/vehicle/dispatch/template/${date}`, {
        method: "GET",
      });
    },
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetDispatchTemplate"] });
    },
  });
};

export const useGetReturnTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (date: string) => {
      return client(`daily/operations/vehicle/return/template/${date}`, {
        method: "GET",
      });
    },
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetReturnTemplate"] });
    },
  });
};

export const useIssueVan = (isVehicleUpdate: boolean) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(
        isVehicleUpdate
          ? `daily/operations/change/van`
          : `daily/operations/issue/van`,
        {
          data,
          successMessage: "Van issued successfully!",
        },
      ),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetStoreRecords"] });
    },
  });
};

export const useIssueVanBulk = () => {
  const queryClient = useQueryClient();

  return useMutation<any, Error, any>({
    mutationFn: (data) =>
      client(`daily/operations/issue/van/bulk`, {
        data,
        successMessage: "Van issued successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetStoreRecords"] });
    },
  });
};

export const useReturnVanBulk = () => {
  const queryClient = useQueryClient();
  return useMutation<any, Error, any>({
    mutationFn: (data) =>
      client(`daily/operations/return/van/bulk`, {
        data,
        successMessage: "Van returned successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetStoreRecords"] });
    },
  });
};

export const useReturnVan = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => client(`daily/operations/return/van`, { data }),
    ...{
      onSuccess: () => {
        queryClient.resetQueries({ queryKey: ["GetStoreRecords"] });
      },
    },
  });
};

export const useGetDailyRouteService = (data: {
  cashCenterId: string;
  operationDate: Date | string;
  routeNo: string;
}) =>
  useQuery<any[]>({
    queryKey: [
      "GetDailyRouteService",
      data.cashCenterId,
      data.operationDate,
      data.routeNo,
    ],
    queryFn: () => client(`daily/operations/route/open/services`, { data }),
  });

export const useUpdateTeamMembers = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/change/field/team/members`, {
        data,
        successMessage: "Field team changed successfully!",
      }),
    ...{
      onSuccess: () => {
        queryClient.resetQueries({ queryKey: ["GetDailyRouteService"] });
      },
    },
  });
};

export const useSwapRouteTeam = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/rosters/swap/team/members`, {
        data,
        successMessage: "Team swapped successfully!",
      }),
    ...{
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["swapRosterTeam"] });
      },
    },
  });
};

export const useGetRostersByData = (
  cashCenterId: string,
  operationDate: string,
) =>
  useQuery<any[]>({
    queryKey: ["GetRouteByCashCenter", cashCenterId],
    queryFn: () =>
      client(`daily/operations/rosters/teams/${cashCenterId}/${operationDate}`),
    enabled: Boolean(cashCenterId),
  });
